import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    paper: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
    },
    title: {
      display: 'flex',
      gap: theme.spacing(0.5),
      alignItems: 'center',
    },
    pointColor: {
      fontSize: 'inherit',
    },
    pointData: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    pointDataLabel: {
      display: 'block',
      whiteSpace: 'nowrap',
      fontSize: 'inherit',
    },
    pointDataValue: {
      display: 'block',
      whiteSpace: 'nowrap',
      fontSize: 'inherit',
      fontWeight: 'bold',
    },
    secondaryData: {
      fontSize: '0.8em',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  };
};
